import React from "react";
import { SortableHandle } from "react-sortable-hoc";
import { ReactComponent as SortableHandleSvg } from "go-component/images/svg/sortable-handle.svg";

const MenuListSortableHandler = SortableHandle(() => {
	return <SortableHandleSvg className="sortable-handler" />;
});

export default MenuListSortableHandler;
